import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchBotResult = createAsyncThunk(
  "bot/fetchResult",
  async (query, thunkAPI) => {
    const q = query.trim().toLowerCase();
    const usersData = thunkAPI.getState().usersData.list || [];

    let results = [];

    const deptMatch = q.match(/^dep(t|artment)?\s*(\d+)$/);
    if (deptMatch) {
      const num = deptMatch[2];
      results = usersData.filter(u => String(u.department || '') === num);
    } else {
      results = usersData.filter(u => {
        const surname = (u.surname || '').toLowerCase();
        const room = String(u.room || '');
        const dept = String(u.department || '');
        return surname.includes(q) || room === q || dept === q;
      });
    }

    if (results.length === 0) return "No results found.";

    return results.map(u => {
      const lines = [
        `${u.surname} — room ${u.room}, dept ${u.department}`,
        u.nutrition    ? `• nutrition: ${u.nutrition}`       : null,
        u.autonomy     ? `• autonomy: ${u.autonomy}`         : null,
        u.bathroom     ? `• bathroom: ${u.bathroom}`         : null,
        u.shaving      ? `• shaving: ${u.shaving}`           : null,
        u.clothes      ? `• clothes: ${u.clothes}`           : null,
        u.accessories  ? `• accessories: ${u.accessories}`   : null,
        u.other        ? `• other: ${u.other}`               : null,
      ].filter(Boolean);
      return lines.join('\n');
    }).join('\n\n');
  }
);

const botSlice = createSlice({
  name: "bot",
  initialState: { response: "" },

  reducers: {
    clearResponse: (state) => {
      state.response = "";
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchBotResult.pending, (state) => {
        state.response = "";
      })
      .addCase(fetchBotResult.fulfilled, (state, action) => {
        state.response = action.payload;
      });
  },
});

export const { clearResponse } = botSlice.actions;

export default botSlice.reducer;
